import VectorSerializer from './Vector';
import Cluster from 'ol/source/Cluster'
import { isDefined, isEmpty, isArray} from '@config/utils';

class ClusterSerializer extends VectorSerializer {
    constructor() {
        super();
        this.sourceCls = Cluster;
    }

    serialize(layer, source, viewRes, map) {
        var me = this;
        me.validateSource(source);
        var extent;

        if (map) {
            extent = map.getView().calculateExtent();
        }
        var format = me.format;
        var geoJsonFeatures = [];
        var mapfishStyleObject = {
            version: 2
        };

        var processFeatures = function(feature) {
            var geometry = feature.getGeometry();
            if (isEmpty(geometry)) {
                // no need to encode features with no geometry
                return;
            }
            var geometryType = geometry.getType();
            var geojsonFeature = format.writeFeatureObject(feature);

            // remove parent feature references as they break serialization
            // later on
            if (geojsonFeature.properties){
                if(geojsonFeature.properties.parentFeature) {
                    geojsonFeature.properties.parentFeature = undefined;
                }
                if(geojsonFeature.properties.features) {
                    geojsonFeature.properties.features = undefined;
                }
            }

            var styles = null;
            var styleFunction = feature.getStyleFunction();
            if (isDefined(styleFunction)) {
                styles = styleFunction.call(feature, viewRes);
            } else {
                styleFunction = layer.getStyleFunction();
                if (isDefined(styleFunction)) {
                    styles = styleFunction.call(layer, feature, viewRes);
                }
            }

            if (!isArray(styles)) {
                styles = [styles];
            }
            if (!isEmpty(styles)) {
                geoJsonFeatures.push(geojsonFeature);
                if (isEmpty(geojsonFeature.properties)) {
                    geojsonFeature.properties = {};
                }
                styles.forEach( (style, j) => {
                    let {obj, id} = me.getUid(style, geometryType);
                    var featureStyleProp = me.FEAT_STYLE_PREFIX + j;
                    me.encodeVectorStyle(
                        mapfishStyleObject,
                        geometryType,
                        style,
                        id,
                        featureStyleProp
                    );
                    geojsonFeature.properties[featureStyleProp] = id;
                });
            }
        };

        if (extent) {
            source.forEachFeatureInExtent(extent, processFeatures);
        } else {
            source.getFeatures().forEach(feature => processFeatures);
        }

        var serialized;

        // MapFish Print fails if there are no style rules, even if there
        // are no features either. To work around this, we add a basic
        // style in the else clause array of GeoJSON features is empty.
        if (geoJsonFeatures.length > 0) {
            var geojsonFeatureCollection = {
                type: 'FeatureCollection',
                features: geoJsonFeatures
            };
            serialized = {
                geoJson: geojsonFeatureCollection,
                opacity: layer.getOpacity(),
                style: mapfishStyleObject,
                type: 'geojson'
            };
        } else {
            serialized = this.FALLBACK_SERIALIZATION;
        }

        return serialized;
    }

};

export default ClusterSerializer;